module.exports = __webpack_public_path__ + "img/no-service.5e2e1739.png";